import { Component, OnInit, AfterViewInit, HostListener, OnDestroy, ViewChild, Inject, ElementRef } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { isODM } from '../../environments/environment';
import { Confirm_button } from '../../environments/environment';
import { AccountService } from '../services/account.service';
import { BehaviorSubject, combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { filter, first, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';
import { TranslateService } from '@ngx-translate/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { MessageService, SelectItem } from 'primeng/api';
import { FloorMap, FloorMapDetails, FloorMapFilters } from '../my-features/floor-map/floor-map.model';
import * as fromFeature from '../my-features';
import { Router } from '@angular/router';
import { MapSite, WorldMap } from '../my-features/world-map/world-map.model';
import { PackageList, statusMapping, updateInfoType, geteventEmitterType } from '../shareModel';
import { ViewDeviceInfo } from '../models/devices';
import { UpdateInfoModel } from '../my-features/updateInfo/update-info.model';
import { DialogComponent } from '../dialog/dialog.component';
import { WorldMapService } from '../services/world-map.service';
import {CryptoService} from '../services/crypto.service';
import { RegionService } from 'src/app/services/region.service';
import { User } from '../models/user';

declare const google: any;
declare var require: any;

@Component({
  standalone: false,
  selector: 'app-globalmap',
  templateUrl: './globalmap.component.html',
  styleUrls: ['./globalmap.component.css']
})
export class GlobalmapComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('globalmap', { static: false }) mapElement: any;
  @ViewChild('locationTextField', { static: false }) locationTextField: any;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;

  powerMaster = isODM;
  map: google.maps.Map;
  mark: google.maps.Marker;

  selectType = 0;
  selectLocation = 'address';
  Confirm_button = Confirm_button;
  displayAddSiteDialog = false;
  disableAddBtn = false;
  disableDeleteBtn = false;

  CountryOptions$: Observable<any>;
  deviceOptions$: Observable<any>;
  groupOptions$: Observable<any>;
  mapOptions: SelectItem[] = [];
  UpdateInfoParam = {} as UpdateInfoModel;

  regionDic = {};
  isMsp = false;
  isClickAdd = false;
  mspSelectedRegionId = [];
  mspCompanyOptionsDic = {};
  mspCompanyOptions = [];
  UserParam = {} as User;
  mspMemberAuthorityDic = {};


  dialogInput: {
    Id?: number;
    name: string;
    address: string;
    latitude: number,
    longitude: number,
    Country: '',
    selectedItem: any;
    companySelectItem: number;
    UpdateTypeStr: string;
    UpdateType: number;
  };

  selectedItem: any = {
    device: NaN,
    group: NaN,
    map: NaN
  };

  showInfo = false;
  buttonIcon = 'fa-caret-left';
  statusCritical: any = [];
  statusWarning: any = [];
  statusOffline: any = [];
  selectLocationType = {
    coordinate: 'coordinate',
    address: 'address'
  };
  private componentDestroyed = new Subject();
  private itemBehaviorSubject: BehaviorSubject<any> = new BehaviorSubject<any>({ type: 0, value: 0, regionId: 0 });
  currentItemBehaviorSubject = this.itemBehaviorSubject.asObservable();
  deviceSnObj = {};
  globalMapNum = 0;
  globalMapLimit = 0;
  mapStyle: any;
  // mspCompanyOptions = [
  //   { label: 'SHI Company', value: 'SHI Company' },
  //   { label: 'SHI One', value: 'SHI One' },
  //   { label: 'ABC Company', value: 'ABC Company' },
  //   { label: 'UPShockTest', value: 'UPShockTest' },
  //   { label: 'Aspen Dental', value: 'Aspen Dental' },
  // ];
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const mainContent = self.innerHeight - 220 + 'px';
    const mainContentHeight = document.getElementsByClassName('main-content')[0] as HTMLElement;
    const contentAreaHeight = document.getElementsByClassName('content-area-map')[0] as HTMLElement;
    mainContentHeight.style.height = mainContent;
    contentAreaHeight.style.height = mainContent;
  }

  constructor(
    private store: Store<fromStore.State>,
    private ngxService: NgxUiLoaderService,
    private translateService: TranslateService,
    private messageService: MessageService,
    private apiService: AccountService,
    private router: Router,
    private worldMapService: WorldMapService,
    private cryptoService: CryptoService,
    private regionService: RegionService) {
    // Get Device List For Options
    this.deviceOptions$ = combineLatest(this.store.select(fromStore.DevicesFiltered),
      this.store.select(fromStore.getWorldMapEntity), this.currentItemBehaviorSubject)
      .pipe(
        takeUntil(this.componentDestroyed),
        switchMap(([item, worldMap, selectItem]) => {
        this.deviceSnObj = item.reduce(function (acc, cur, i) {
          acc[cur.dcode] = cur;
          return acc;
        }, {});
        // const newItem = item.filter((i) => {
        //   return !i.isExpired && (!worldMap['0'].hasOwnProperty(i.dcode) || (selectItem.type === 0 && selectItem.value == i.dcode));
        // }).map(i => ({ label: i.name, value: Number(i.dcode) }));
        // debugger;
        // return of([{ label: TRANSLATE('Select Device'), value: NaN }, ...newItem]);

        if (this.isMsp) {
          const newItem = item.filter((i) => {
            return !i.isExpired && (selectItem.regionId === i.regionId);
          }).map(i => ({ label: i.name, value: Number(i.dcode) }));
          // debugger;
          return of([{ label: TRANSLATE('Select Device'), value: NaN }, ...newItem]);
        } else {
          const newItem = item.filter((i) => {
            return !i.isExpired && (!worldMap['0'].hasOwnProperty(i.dcode) || (selectItem.type === 0 && selectItem.value == i.dcode));
          }).map(i => ({ label: i.name, value: Number(i.dcode) }));
          // debugger;
          return of([{ label: TRANSLATE('Select Device'), value: NaN }, ...newItem]);
        }

      }));

    // Get Group List For Options
    this.groupOptions$ = combineLatest(this.store.select(fromStore.getGroupsNameListWithDeviceExpiredInfo),
      this.store.select(fromStore.getWorldMapEntity), this.currentItemBehaviorSubject)
      .pipe(
        takeUntil(this.componentDestroyed),
        switchMap(([item, worldMap, selectItem]) => {
        // return of(item.filter((i) => {
        //   // tslint:disable-next-line:triple-equals
        //   return !worldMap['1'].hasOwnProperty(i.value) || (selectItem.type === 1 && selectItem.value == i.value);
        // }));

        if (this.isMsp) {
          // debugger;
          return of(item.filter((i) => {
            // tslint:disable-next-line:triple-equals
            return (selectItem.regionId === i.regionId && !i.allDeviceExpired) || (i.regionId === -1);
          }));
        } else {
          // debugger;
          return of(item.filter((i) => {
            // tslint:disable-next-line:triple-equals

            return !worldMap['1'].hasOwnProperty(i.value) || (selectItem.type === 1 && selectItem.value == i.value);
          }));
        }

      }));

    // Get FloorMap List For Options
    combineLatest(this.store.select(fromStore.getFloorMapNameList), this.store.select(fromStore.getWorldMapEntity),
      this.currentItemBehaviorSubject).pipe(takeUntil(this.componentDestroyed)).subscribe(([item, worldMap, selectItem]) => {
        let mapArr = [];
        if (item && item.length > 0) {
          mapArr = item.filter((i) => {
            // tslint:disable-next-line:triple-equals
            return !worldMap['2'].hasOwnProperty(i.value) || (selectItem.type === 2 && selectItem.value == i.value);
          });
          this.mapOptions = mapArr;
        }
      });

    // Get Country List For Options
    this.CountryOptions$ = this.store.select(fromStore.getCountryList).pipe(map((res) => {
      let result = [];
      result = res.entities.map((item) => {
        return { label: item, value: item };
      });
      result.unshift({ label: TRANSLATE('Please Select:'), value: null });
      return result;
    }));

    // Get Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if ((res.type === updateInfoType.AddWorldMap || res.type === updateInfoType.EditWorldMap ||
        res.type === updateInfoType.DeleteWorldMap || res.type === updateInfoType.GetWorldMap)
        && !res.isLoading && res.isLoaded) {
        if (res.type !== updateInfoType.GetWorldMap) {
          if (res.isSaved) {
            this.messageService.add({ severity: 'success', summary: this.translateService.instant('Update Success') });
          } else {
            this.messageService.add({ severity: 'error', summary: this.translateService.instant('Update Fail') });
            this.reloadGlobalMap();
          }
        }
        this.resetUpdateInfoState();
        this.ngxService.stop();
      }
    });

    this.packageSetting();

    // Msp Data
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getRegions),
    this.store.select(fromStore.getMspMemberAuthority)).pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getRegionsRes, getMspMemberAuthorityRes]) => {
      if ((getIsMspRes !== undefined && getIsMspRes !== null) &&
          (getRegionsRes.length > 0) &&
          ((getMspMemberAuthorityRes !== null && Array.isArray(getMspMemberAuthorityRes) && getMspMemberAuthorityRes.length > 0)) ) {

        // Get isMsp
        this.isMsp = getIsMspRes;

        // Get region
        this.regionDic = {};
        getRegionsRes.map((item) => {
          this.regionDic[item.Id] = item.RegionName;
        });

        // Get Msp Member Authority For Filter Bar
        this.mspCompanyOptionsDic = {};
        this.mspMemberAuthorityDic = {};
        if (this.isMsp) {
          getMspMemberAuthorityRes.map((m) => {
            this.mspMemberAuthorityDic[m.RegionId] = m;
            if (this.regionDic[m.RegionId] !== null && this.regionDic[m.RegionId] !== undefined) {
              this.mspCompanyOptionsDic[m.RegionId] = this.regionDic[m.RegionId];
            }
          });
        }
      }
    });

    // 左上選單值有更新時
    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.mspSelectedRegionId = [];
      if (res !== undefined && res !== null && res.filterLoaded) {
        if (res.selectedId !== undefined && res.selectedId !== null && res.selectedId.length > 0) {
          this.mspSelectedRegionId = res.selectedId;
        }
        this.reloadGlobalMap();
      }
    });
  }

  ngOnInit(): void {
    this.UI();
    // this.statusCritical = this.globalMapSiteArray.filter(elm => elm.status === 'critical');
    // this.statusWarning = this.globalMapSiteArray.filter(elm => elm.status === 'warning');
    // this.statusOffline = this.globalMapSiteArray.filter(elm => elm.status === 'offline');
    this.initDialogInput();
    // 移除 this.InitialMap(); 到 ngAfterViewInit
    // this.reloadGlobalMap();


  }

  ngAfterViewInit(): void {
    // @ViewChild 元素在此時已初始化，可以安全訪問
    this.InitialMap();
  }

  updateBehaviorSubject(data) {
    this.itemBehaviorSubject.next(data);
  }

  reloadGlobalMap() {
    this.ngxService.start();
    // let regionIdsFromStorage = [];
    // if (this.regionService.GetRegionIds != null && this.regionService.GetRegionIds !== undefined && this.regionService.GetRegionIds.length > 0) {
    //     regionIdsFromStorage = this.regionService.GetRegionIds.split(',').map(str => parseInt(str, 10));
    // }
    if (this.isMsp && (Object.keys(this.mspCompanyOptionsDic).length > 0 || this.mspSelectedRegionId.length > 0)) {
      const param = {
        regionIds : this.mspSelectedRegionId
      };
      // this.UserParam.regionIds = param.regionIds;
      // this.store.dispatch(new fromStore.GetDevicesStatusAction(this.UserParam));
      // this.store.dispatch(new fromStore.GetGroups(param));
      // this.store.dispatch(new fromStore.GetDeviceInfoAction(param));

      this.mspCompanyOptions = [];
      this.disableAddBtn = false;
      param.regionIds.map((id) => {
        if (this.mspMemberAuthorityDic[id] !== undefined && this.mspMemberAuthorityDic[id].ViewDevice === 1) {
          if (this.mspMemberAuthorityDic[id].EditDevice === 1) {
            this.mspCompanyOptions.push({ label: this.mspCompanyOptionsDic[id], value: id});
            if (this.mspCompanyOptions.length > 0) {
              const ids = [];
              this.mspCompanyOptions.forEach(e => {
                ids.push(e.value);
              });
              if (!ids.includes(id)) {
                this.mspCompanyOptions.push({ label: this.mspCompanyOptionsDic[id], value: id});
              }
            } else {
              this.mspCompanyOptions.push({ label: this.mspCompanyOptionsDic[id], value: id});
            }
          }
        }
      });
      this.store.dispatch(new fromFeature.GetWorldMaps(param));
    } else {
      // this.store.dispatch(new fromStore.GetDevicesStatusAction());
      // this.store.dispatch(new fromStore.GetGroups());
      // this.store.dispatch(new fromStore.GetDeviceInfoAction());
      this.store.dispatch(new fromFeature.GetWorldMaps());
    }
  }

  InitialMap() {
    const body = document.getElementsByTagName('body')[0];
    if (body.classList.contains('dark')) {
      this.mapStyle = [
        {
          'featureType': 'all',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'saturation': 36
            },
            {
              'color': '#000000'
            },
            {
              'lightness': 40
            }
          ]
        },
        {
          'featureType': 'all',
          'elementType': 'labels.text.stroke',
          'stylers': [
            {
              'visibility': 'on'
            },
            {
              'color': '#000000'
            },
            {
              'lightness': 16
            }
          ]
        },
        {
          'featureType': 'all',
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'administrative',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 20
            }
          ]
        },
        {
          'featureType': 'administrative',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 17
            },
            {
              'weight': 1.2
            }
          ]
        },
        {
          'featureType': 'administrative',
          'elementType': 'labels',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'administrative.country',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'simplified'
            }
          ]
        },
        {
          'featureType': 'administrative.country',
          'elementType': 'geometry',
          'stylers': [
            {
              'visibility': 'simplified'
            }
          ]
        },
        {
          'featureType': 'administrative.country',
          'elementType': 'labels.text',
          'stylers': [
            {
              'visibility': 'simplified'
            }
          ]
        },
        {
          'featureType': 'administrative.province',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'administrative.locality',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'simplified'
            },
            {
              'saturation': '-100'
            },
            {
              'lightness': '30'
            }
          ]
        },
        {
          'featureType': 'administrative.neighborhood',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'administrative.land_parcel',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'landscape',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'simplified'
            },
            {
              'gamma': '0.00'
            },
            {
              'lightness': '74'
            }
          ]
        },
        {
          'featureType': 'landscape',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 20
            }
          ]
        },
        {
          'featureType': 'landscape.man_made',
          'elementType': 'all',
          'stylers': [
            {
              'lightness': '3'
            }
          ]
        },
        {
          'featureType': 'poi',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'poi',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 21
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'geometry',
          'stylers': [
            {
              'visibility': 'simplified'
            }
          ]
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 17
            }
          ]
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 29
            },
            {
              'weight': 0.2
            }
          ]
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 18
            }
          ]
        },
        {
          'featureType': 'road.local',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 16
            }
          ]
        },
        {
          'featureType': 'transit',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 19
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#000000'
            },
            {
              'lightness': 17
            }
          ]
        }
      ];
    } else {
      this.mapStyle = [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              'color': '#e9e9e9'
            },
            {
              'lightness': 17
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              'color': '#f5f5f5'
            },
            {
              'lightness': 20
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              'color': '#ffffff'
            },
            {
              'lightness': 17
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              'color': '#ffffff'
            },
            {
              'lightness': 29
            },
            {
              'weight': 0.2
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [
            {
              'color': '#ffffff'
            },
            {
              'lightness': 18
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [
            {
              'color': '#ffffff'
            },
            {
              'lightness': 16
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              'color': '#f5f5f5'
            },
            {
              'lightness': 21
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              'color': '#dedede'
            },
            {
              'lightness': 21
            }
          ]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              'visibility': 'on'
            },
            {
              'color': '#ffffff'
            },
            {
              'lightness': 16
            }
          ]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              'saturation': 36
            },
            {
              'color': '#333333'
            },
            {
              'lightness': 40
            }
          ]
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [
            {
              'color': '#f2f2f2'
            },
            {
              'lightness': 19
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [
            {
              'color': '#fefefe'
            },
            {
              'lightness': 20
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [
            {
              'color': '#fefefe'
            },
            {
              'lightness': 17
            },
            {
              'weight': 1.2
            }
          ]
        }
      ];
    }
    const mapOptions = {
      center: new google.maps.LatLng(24.980415, 121.548664),
      zoom: 2,
      minZoom: 1,
      maxZoom: 15,
      disableDefaultUI: true,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      styles: this.mapStyle
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    // custom zoom controls
    const zoomControlDiv = document.createElement('div');
    // 直接調用 ZoomControl 方法，不使用 new 關鍵字
    this.ZoomControl(zoomControlDiv, this.map);
    this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv);
    const MarkerWithLabel = require('markerwithlabel')(google.maps);
    const options = {
      componentRestrictions: { country: 'tw' } // 限制在台灣範圍
    };
    // const input = this.locationTextField.nativeElement as HTMLInputElement;
    // const autocomplete = new google.maps.places.Autocomplete(input, options);
    // const place = autocomplete.getPlace();

    // const input = document.getElementById('pac-input') as HTMLInputElement;
    // const autocomplete = new google.maps.places.Autocomplete(input);
    // autocomplete.bindTo('bounds', this.map);
    // autocomplete.addListener('place_changed', (result) => {
    //   const place = autocomplete.getPlace();
    //   console.log(place);
    //   console.log(result);
    // });
    let markers = [];
    const othis = this;
    // Get Global Info
    combineLatest(this.store.select(fromStore.getWorldMap),
      this.store.select(fromStore.DevicesFiltered),
      this.store.select(fromStore.getGroupDevices),
      this.store.select(fromStore.getFloorMapInfoForGlobalMap))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([worldMap, deviceArr, groupArr, floorMap]) => {
        let floorMapArr: FloorMap[] = [];
        const infowindow = new google.maps.InfoWindow();
        floorMapArr = floorMap.map((item: FloorMap) => {
          let deviceStatusCode = 0;
          if (item.details && item.details.length > 0) {
            deviceStatusCode = Math.max(...item.details.map((i) => {
              return Number(i.statusCode);
            })) || 0;
          }
          return { ...item, deviceStatusCode: deviceStatusCode };
        });
        othis.statusCritical = [];
        othis.statusWarning = [];
        othis.statusOffline = [];
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers = [];
        if (worldMap) {
          othis.globalMapNum = worldMap.length;
          // reset the label(markers)
          worldMap.forEach((item: WorldMap) => {
            const result: any = {
              Id: item.Id,
              name: item.Name,
              country: item.Country,
              lat: item.Lat,
              lng: item.Lon,
              selectType: item.Type,
              selectLocation: (item.Address) ? this.selectLocationType.address : this.selectLocationType.coordinate,
              address: item.Address,
              normal: 0,
              critical: 0,
              warning: 0,
              offline: 0,
              ownerId: item.OwnerId,
              isExpired: false,
              HashDeviceSn: '',
              HashOwnerId: this.cryptoService.aesEncrypt(item.OwnerId),
              company: item.RegionId,
              displayEditBtn: false
            };
            if (this.mspMemberAuthorityDic[item.RegionId] !== undefined && this.mspMemberAuthorityDic[item.RegionId].ViewDevice === 1) {
              if (this.mspMemberAuthorityDic[item.RegionId].EditDevice !== 1) {
                result.displayEditBtn = true;
              }
            }
            const statusMap = statusMapping;
            let deviceStatus = 3; // default offline.
            switch (item.Type) {
              case 0:
                // tslint:disable-next-line:triple-equals
                const deviceInfo = deviceArr.find((i) => i.dcode == item.OwnerId);
                if (deviceInfo) {
                  result.HashDeviceSn = this.cryptoService.aesEncrypt(deviceInfo.DeviceSN);
                  deviceStatus = deviceInfo.deviceStatusCode;
                  result.isExpired = deviceInfo.isExpired;
                } else {
                  result.isExpired = true;
                }
                break;
              case 1:
                const groupInfo = groupArr.find((i) => i.data.gId === item.OwnerId);
                if (groupInfo) {
                  deviceStatus = groupInfo.data.deviceStatusCode;
                  if (groupInfo.children && groupInfo.children.length > 0) {
                    groupCalStatus(result, groupInfo.children);
                  }
                } else {
                  result.isExpired = true;
                }
                break;
              case 2:
                const floorMapInfo = floorMapArr.find((i) => i.id === item.OwnerId);
                if (floorMapInfo) {
                  deviceStatus = floorMapInfo.deviceStatusCode;
                } else {
                  result.isExpired = true;
                }
                if (floorMapInfo && floorMapInfo.details.length > 0) {
                  floorMapCalStatus(result, floorMapInfo.details);
                }
            }
            result.statusImg = `../assets/images/icon_${statusMap[deviceStatus].status}.png`;
            result.statusIcon = statusMap[deviceStatus].icon;
            result.status = statusMap[deviceStatus].status;
            generateMarker(result);
            // Total count for toggle menu.
            switch (deviceStatus) {
              case 1:
                othis.statusWarning.push(result);
                break;
              case 2:
                othis.statusCritical.push(result);
                break;
              case 3:
                othis.statusOffline.push(result);
                break;
              default:
            }
          });
        }

        function groupCalStatus(info: MapSite, groupChild) {
          groupChild.forEach((i) => {
            const item: ViewDeviceInfo = i.data;
            const status = item.deviceStatusCode;
            switch (status) {
              case 0:
                info.normal += 1;
                break;
              case 1:
                info.warning += 1;
                break;
              case 2:
                info.critical += 1;
                break;
              case 3:
                info.offline += 1;
                break;
              default:
            }
          });
        }
        function floorMapCalStatus(info: MapSite, mapDetail) {
          mapDetail.forEach((i: FloorMapDetails) => {
            const status = i.statusCode;
            switch (status) {
              case 0:
                info.normal += 1;
                break;
              case 1:
                info.warning += 1;
                break;
              case 2:
                info.critical += 1;
                break;
              default:
            }
          });
        }
        function generateMarker(item) {
          const contentString =
            '<div class="infowindow">' +
            '<div class="contentBox">' +
            '<i class="fa status ' + item.statusIcon + '" aria-hidden="true"></i>' +
            '<h3>' + item.name + '</h3>' +
            '<h5>' + item.country + '</h5>' +
            '<div class="button">' +
            ((item.isExpired) ? '' :
              `<button type="button" class="btn btn-sm p-button-rounded link" (click)="linkSiteDetail()">${othis.translateService.instant('Detail')}</button>`) +
            ((item.displayEditBtn) ? '' :
              `<button type="button" class="btn btn-sm p-button-rounded edit" (click)="showEditSite()">${othis.translateService.instant('Edit')}</button>`) +
            '</div>' +
            '</div>' +
            '</div>';
          const contentGroupString =
            '<div class="infowindow">' +
            '<div class="contentBox">' +
            '<i class="fa status ' + item.statusIcon + '" aria-hidden="true"></i>' +
            '<h3>' + item.name + '</h3>' +
            '<h5>' + item.country + '</h5>' +
            '<ul>' +
            '<li><i class="fa fa-check-circle"></i> ' + item.normal + '</li>' +
            '<li><i class="fa fa-times-circle"></i> ' + item.critical + '</li>' +
            '<li><i class="fa fa-exclamation-circle"></i> ' + item.warning + '</li>' +
            '<li><i class="fa fa-question-circle"></i> ' + item.offline + '</li>' +
            '</ul>' +
            '<div class="button">' +
            ((item.isExpired) ? '' :
              `<button type="button" class="btn btn-sm p-button-rounded link" (click)="linkSiteDetail()">${othis.translateService.instant('Detail')}</button>`) +
            ((item.displayEditBtn) ? '' :
              `<button type="button" class="btn btn-sm p-button-rounded edit" (click)="showEditSite()">${othis.translateService.instant('Edit')}</button>`) +
            '</div>' +
            '</div>' +
            '</div>';
          const marker = new MarkerWithLabel({
            title: item.name,
            position: { lat: item.lat, lng: item.lng },
            draggable: false,
            raiseOnDrag: false,
            map: othis.map,
            icon: {
              url: item.statusImg,
            },
            labelContent: item.name,
            labelAnchor: new google.maps.Point(-12, 16),
            labelClass: 'labels',
            labelStyle: {
              opacity: 1,
              color: '#000000',
              fontWeight: 'bold',
            },
            name: item.name,
            address: item.address,
            lat: parseFloat(item.lat),
            lng: parseFloat(item.lng),
            country: item.country,
            selectLocation: item.selectLocation,
            selectType: item.selectType,

            ownerId: item.ownerId,
            Id: item.Id,
            isExpired: item.isExpired,
            company: item.company
          });
          marker.addListener('click', function () {
            if (item.selectType === 0) {
              infowindow.setContent(contentString);
            } else {
              infowindow.setContent(contentGroupString);
            }
            infowindow.open(Map, this);
          });
          markers.push(marker);
        }

        google.maps.event.addListener(infowindow, 'domready', () => {
          const el = document.getElementsByClassName('edit')[0];
          if (el) {
            el.addEventListener('click', (event) => othis.showEditSite(event, infowindow) , {passive: true});
          }
          const ele = document.getElementsByClassName('link')[0];
          if (ele) {
            ele.addEventListener('click', (event) => othis.linkSiteDetail(event, infowindow) , {passive: true});
          }
        });
      });
  }

  initDialogInput() {
    this.updateBehaviorSubject({ type: 0, value: 0, regionId: -1 });
    this.dialogInput = {
      Id: NaN,
      name: '',
      address: '',
      latitude: NaN,
      longitude: NaN,
      Country: '',
      selectedItem: NaN,
      companySelectItem: NaN,
      UpdateTypeStr: 'Add Site',
      UpdateType: 1,
    };
    this.selectLocation = 'address';
    this.selectType = 0;
  }

  applyGeoInfoByAddress(event: any) {
    if (!event.target.value) {
      return;
    }
    // this.ngxService.start();
    this.worldMapService.GetGeoLocationByAddress(event.target.value).pipe(first()).subscribe((res) => {
      if (res.status === 'OK' && Array.isArray(res.results) && res.results.length > 0) {
        this.dialogInput.latitude = res.results[0].geometry.location.lat;
        this.dialogInput.longitude = res.results[0].geometry.location.lng;
      } else {
        // this.dialogInput.latitude = NaN;
        // this.dialogInput.longitude = NaN;
      }
      // this.ngxService.stop();
    });
  }

  checkLatitude(event: any) {
    if (!event.target.value) {
      // this.dialogInput.latitude = NaN;
      this.dialogInput.address = '';
      return;
    }
  }

  checkLongitude(event: any) {
    if (!event.target.value) {
      // this.dialogInput.longitude = NaN;
      this.dialogInput.address = '';
      return;
    }
  }

  checkAddress(event: any) {
    if (this.dialogInput.address === '') {
      return;
    }
    this.worldMapService.GetGeoLocationByAddress(this.dialogInput.address).pipe(first()).subscribe((res) => {
      if (res.status === 'OK' && Array.isArray(res.results) && res.results.length > 0) {
        this.dialogInput.latitude = res.results[0].geometry.location.lat;
        this.dialogInput.longitude = res.results[0].geometry.location.lng;
      } else {
        this.dialogInput.latitude = NaN;
        this.dialogInput.longitude = NaN;
      }
    });
  }

  addSiteClick() {
    this.isClickAdd = true;
    if (this.globalMapLimit <= this.globalMapNum) {
      this.childDialog.dialogType.globalMapLimit = true;
      return;
    }
    this.initDialogInput();
    this.displayAddSiteDialog = true;
  }

  addSiteSave() {
    const params: WorldMap = {
      id: this.dialogInput.Id,
      Name: this.dialogInput.name,
      Country: this.dialogInput.Country,
      Type: Number(this.selectType),
      OwnerId: this.dialogInput.selectedItem,
      Address: (this.selectLocation === 'address') ? this.dialogInput.address : '',
      Lon: this.dialogInput.longitude,
      Lat: this.dialogInput.latitude,
      // Lon: (this.dialogInput.longitude === null) ? NaN : this.dialogInput.longitude,
      // Lat: (this.dialogInput.latitude === null) ? NaN : this.dialogInput.latitude,
    };
    if (this.isMsp) {
      params.RegionId = this.dialogInput.companySelectItem;
    }

    if (this.dialogInput.UpdateType === 2) {
      this.ngxService.start();
      this.dispatchUpdateInfoAction(updateInfoType.EditWorldMap);
      this.store.dispatch(new fromFeature.GetUpdateWorldMaps({ worldMaps: params }));
    } else if (this.dialogInput.UpdateType === 1) {
      this.ngxService.start();
      this.dispatchUpdateInfoAction(updateInfoType.AddWorldMap);
      this.store.dispatch(new fromFeature.GetAddWorldMaps({ worldMaps: params }));
    }
    this.displayAddSiteDialog = false;
  }

  showEditSite(event, infowindow) {
    this.isClickAdd = false;
    this.disableDeleteBtn = false;
    if (!infowindow.anchor) {
      return;
    }
    this.dialogInput = {
      Id: infowindow.anchor.Id,
      name: infowindow.anchor.name,
      address: infowindow.anchor.address,
      latitude: infowindow.anchor.lat,
      longitude: infowindow.anchor.lng,
      Country: infowindow.anchor.country,
      selectedItem: infowindow.anchor.ownerId,
      companySelectItem: infowindow.anchor.company,
      UpdateTypeStr: 'Edit Site',
      UpdateType: 2
    };

    // if (this.isMsp) {
    //   let regionIds = [];
    //   regionIds.push(infowindow.anchor.company)
    //   const param = {
    //     regionIds : regionIds
    //   };
    //   this.store.dispatch(new fromStore.GetGroups(param));
    //   this.store.dispatch(new fromStore.GetDeviceInfoAction(param));
    // }

    if (this.dialogInput.UpdateType === 2) {
      this.updateBehaviorSubject({ type: infowindow.anchor.selectType, value: this.dialogInput.selectedItem, regionId: infowindow.anchor.company });
    } else {
      this.updateBehaviorSubject({ type: 0, value: 0, regionId: infowindow.anchor.company });
    }
    if (this.mspMemberAuthorityDic[this.dialogInput.companySelectItem] !== undefined && this.mspMemberAuthorityDic[this.dialogInput.companySelectItem].ViewDevice === 1) {
      if (this.mspMemberAuthorityDic[this.dialogInput.companySelectItem].EditDevice !== 1) {
        this.disableDeleteBtn = true;
      }
    }

    this.selectLocation = infowindow.anchor.selectLocation;
    this.selectType = infowindow.anchor.selectType;

    this.displayAddSiteDialog = true;
    infowindow.close(Map, this);
  }

  checkSiteSave() {
    if (this.selectType === 0 &&
      (!this.deviceSnObj.hasOwnProperty(this.dialogInput.selectedItem) || this.deviceSnObj[this.dialogInput.selectedItem].isExpired)) {
      return true;
    }
    if (isNaN(this.dialogInput.latitude) || this.dialogInput.latitude === null || isNaN(this.dialogInput.longitude) ||
    this.dialogInput.longitude === null || !this.dialogInput.name || (isNaN(this.dialogInput.selectedItem) ||
    // this.dialogInput.latitude === -0 || this.dialogInput.longitude === -0 || 
    this.dialogInput.selectedItem <= 0) || !this.dialogInput.Country) {
      return true;
    }
    if (this.selectLocation === 'address' && this.dialogInput.address === '') {
      return true;
    }

    if (this.isMsp && this.isClickAdd) {
      if (isNaN(this.dialogInput.companySelectItem)) {
        return true;
      }
    }
    return false;
  }

  deleteSite() {
    if (this.dialogInput.Id) {
      this.ngxService.start();
      this.dispatchUpdateInfoAction(updateInfoType.DeleteWorldMap);
      this.store.dispatch(new fromFeature.GetDeleteWorldMaps({ id: this.dialogInput.Id.toString() }));
    }
    this.displayAddSiteDialog = false;
  }

  linkSiteDetail(event, infowindow) {
    // 設定連結
    const item = infowindow.anchor;
    if (!item.isExpired && item.selectType === 0) {
      if (this.deviceSnObj.hasOwnProperty(item.ownerId)) {
        const pathname = this.cryptoService.aesEncrypt(this.deviceSnObj[item.ownerId].DeviceSN);
        this.router.navigate([`/detail/` + pathname]);
      }
    } else if (!item.isExpired && item.selectType === 1) {
      const pathname = this.cryptoService.aesEncrypt(item.ownerId);
      this.router.navigate([`/group_detail/` + pathname]);
    } else if (!item.isExpired && item.selectType === 2) {
      const pathname = this.cryptoService.aesEncrypt(item.ownerId);
      this.router.navigate([`/devicemap/edit/` + pathname]);
    }
  }

  mspCompanyOptionsChange() {
    const selectId = this.dialogInput.companySelectItem;
    // if (this.dialogInput.UpdateType === 2) {
    //   this.updateBehaviorSubject({ type: infowindow.anchor.selectType, value: this.dialogInput.selectedItem, regionId: selectId });
    // } else {
    //   this.updateBehaviorSubject({ type: 0, value: 0, regionId: selectId });
    // }
    this.updateBehaviorSubject({ type: 0, value: 0, regionId: selectId });
  }

  // custom zoom controls, tslint:disable-next-line: no-shadowed-variable
  ZoomControl(controlDiv, map) {
    // Creating divs & styles for custom zoom control
    controlDiv.style.padding = '10px';
    // Set CSS for the control wrapper
    const controlWrapper = document.createElement('div');
    controlWrapper.classList.add('controlWrapper');
    controlWrapper.style.textAlign = 'center';
    controlWrapper.style.width = '40px';
    controlWrapper.style.height = '80px';
    controlDiv.appendChild(controlWrapper);

    // Set CSS for the zoomIn
    const zoomInButton = document.createElement('button');
    zoomInButton.style.width = '40px';
    zoomInButton.style.height = '40px';
    zoomInButton.classList.add('zoomIn');
    controlWrapper.appendChild(zoomInButton);

    // Set CSS for the zoomOut
    const zoomOutButton = document.createElement('button');
    zoomOutButton.classList.add('zoomOut');
    zoomOutButton.style.width = '40px';
    zoomOutButton.style.height = '40px';
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    // google.maps.event.addDomListener() is deprecated, use the standard addEventListener() method instead
    zoomInButton.addEventListener('click',
      (evt) => {
        map.setZoom(map.getZoom() + 1);
      }
    );

    // Setup the click event listener - zoomOut
    // google.maps.event.addDomListener() is deprecated, use the standard addEventListener() method instead
    zoomOutButton.addEventListener('click',
      (evt) => {
        map.setZoom(map.getZoom() - 1);
      }
    );

  }

  // 此Function沒被用到
  initAutoComplete() {
    const options = {
      componentRestrictions: { country: 'tw' } // 限制在台灣範圍
    };
    const input = this.locationTextField.nativeElement as HTMLInputElement;
    // const input = document.getElementById('locationTextField') as HTMLInputElement;
    const autocomplete = new google.maps.places.Autocomplete(input, options);

    // const infowindow = new google.maps.InfoWindow();
    // const infowindowContent = document.getElementById(
    //   'infowindow-content'
    // ) as HTMLElement;
    // infowindow.setContent(infowindowContent);
    // autocomplete.setFields(["address_components", "geometry", "icon", "name"]);
    const place = autocomplete.getPlace();

    // google.maps.event.addListener(autocomplete, 'place_changed', () => {
    //   const lat = place.geometry.location.lat();
    //   const lng = place.geometry.location.lng();
    //   console.log(place);
    //   console.log(lat);
    //   console.log(lng);
    // });
    // autocomplete.addListener( 'place_changed',
    //   function() {
    //     const place = autocomplete.getPlace();
    //     const lat = place.geometry.location.lat();
    //     const lng = place.geometry.location.lng();
    //     console.log(place);
    //     console.log(lat);
    //     console.log(lng);
    //   });
  }

  toggleMapInfo() {
    this.showInfo = !this.showInfo;
    const el = document.getElementsByClassName('mapAlarmsInfo')[0];
    if (this.showInfo) {
      this.buttonIcon = 'fa-caret-right';
      el.classList.add('hide');
    } else {
      this.buttonIcon = 'fa-caret-left';
      el.classList.remove('hide');
    }
  }

  packageSetting() {
    // Global map limit
    this.store.select(fromStore.getIsActiveUserModule, PackageList.SiteLimit).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.globalMapLimit = Number(res);
    });
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');

    const mainContent = self.innerHeight - 220 + 'px';
    const mainContentHeight = document.getElementsByClassName('main-content')[0] as HTMLElement;
    const contentAreaHeight = document.getElementsByClassName('content-area-map')[0] as HTMLElement;
    mainContentHeight.style.height = mainContent;
    contentAreaHeight.style.height = mainContent;

    const el = document.getElementsByClassName('mapAlarmsInfo')[0];
    if (innerWidth < 768) {
      this.buttonIcon = 'fa-caret-right';
      el.classList.add('hide');
    } else if (innerWidth < 768) {
      this.buttonIcon = 'fa-caret-left';
      el.classList.remove('hide');
    }
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  private dispatchUpdateInfoAction(type: string): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoAction({ ...this.UpdateInfoParam }));
  }

}
